import Dashboard from "./dashboard.vue";

const dashboardRoutes = [
  {
    path: "",
    component: Dashboard,
    name: "dashboard.index",
    meta: {
      auth: {
        roles: "course.index",
        redirect: { name: "auth.login" }
      }
    }
  }
];

export default dashboardRoutes;
